module.exports = __webpack_public_path__ + "img/led-background.ac5e9f6f.jpg";